import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VList,
    _vm._b(
      { staticClass: "v-menu-list", attrs: { dense: "", nav: "" } },
      "v-list",
      _vm.$attrs,
      false
    ),
    [
      _c(
        VListItemGroup,
        {
          model: {
            value: _vm.activeItem,
            callback: function ($$v) {
              _vm.activeItem = $$v
            },
            expression: "activeItem",
          },
        },
        _vm._l(_vm.items, function (item) {
          return _c(
            VListItem,
            { key: item.title },
            [
              _c(
                VListItemIcon,
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { right: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(VIcon, _vm._g({}, on), [
                                  _vm._v(_vm._s(item.icon)),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_vm._v(" "), _c("span", [_vm._v(_vm._s(item.title))])]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VListItemContent,
                [_c(VListItemTitle, [_vm._v(_vm._s(item.title))])],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }